import {ENOTCONN} from 'constants';

export default [
	{
		title: 'Food',
		color: '#0087AB',
		rows: [
			[
				{
					title: 'Food at home/ Groceries',
					subtitle: '',
					info:
						'Food at home refers to the total expenditures for food at grocery stores (or other food stores) and food prepared by the consumer unit on trips. It excludes the purchase of nonfood items.'
				},
				{
					title: 'Restaurants',
					subtitle: '',
					info:
						'Restaurants includes all meals (breakfast and brunch, lunch, dinner and snacks and beverages) including tips at fast food, take-out, delivery, concession stands, buffet and cafeteria, at full-service restaurants, and at vending machines and mobile vendors. Also included are board (including at school), meals as pay, special catered affairs, such as weddings, bar mitzvahs, and confirmations, school lunches, and meals away from home on trips.'
				},
				{
					title: 'Beverages',
					subtitle: '(alcohol, non alcohol)',
					info:
						'Alcoholic beverages includes beer and ale, wine, whiskey, gin, vodka, rum, and other alcoholic beverages. Nonalcoholic beverages includes diet and nondiet carbonated drinks (cola, fruit, and other carbonated drinks); coffee (roasted, instant, and freeze dried); tea (loose, instant, and ready-to-drink); ice; nonalcoholic beer; and other nonalcoholic beverages, including noncarbonated fruit drinks, breakfast substitutes, chocolate flavored powders; others.'
				},
				{
					title: 'Other',
					subtitle: '(input your own)',
					info:
						'Other spendings for food and beverages, not included in the above categories'
				}
			]
		]
	},

	{
		title: 'Housing',
		color: '#7FD2E8',
		rows: [
			[
				{
					title: 'Owned dwellings',
					subtitle: '',
					info:
						'Owned dwellings includes interest on mortgages, interest on home equity loans and lines of credit, property taxes and insurance, refinancing and prepayment charges, ground rent, expenses for property management and security, homeowners insurance, fire insurance and extended coverage, expenses for repairs and maintenance contracted out, and expenses of materials for owner-performed repairs and maintenance for dwellings used or maintained by the consumer unit. '
				},
				{
					title: 'Rented dwellings',
					subtitle: '',
					info:
						'Rented dwellings includes rent paid for dwellings, rent received as pay, parking fees, maintenance, and other expenses.'
				},
				{
					title: 'Other lodging',
					subtitle: '',
					info:
						'Other lodging includes all expenses for vacation homes, school, college, hotels, motels, and other lodging while out of town.'
				},
				{
					title: 'Utilities ',
					subtitle: '(fuels, public services, etc..)',
					info:
						'Utilities, fuels, and public services includes natural gas; electricity; fuel oil and other fuels, such as wood, kerosene, coal, and bottled gas; water and other public services, such as garbage and trash collection, sewerage maintenance, septic tank cleaning; and telephone charges.'
				}
			],
			[
				{
					title: 'Personal services',
					subtitle: '',
					info:
						'Personal services includes baby-sitting; day care, nursery school, and preschool tuition; care of the elderly, invalids and handicapped; adult day care; and domestic and other duties.'
				},
				{
					title: 'Housekeeping supplies',
					subtitle: '',
					info:
						'Housekeeping supplies includes laundry and cleaning supplies, cleaning and toilet tissues, stationery supplies, postage, delivery services, miscellaneous household products, and lawn and garden supplies.'
				},
				{
					title: 'Household textiles',
					subtitle: '',
					info:
						'Household textiles includes bathroom, bedroom, kitchen and dining room, other linens, curtains and drapes, slipcovers and decorative pillows, and sewing materials.'
				},
				{
					title: 'Furniture',
					subtitle: '',
					info:
						'Furniture includes living room; dining room; kitchen; bedroom; nursery; porch, lawn, and other outdoor furniture.'
				}
			],
			[
				{
					title: 'Appliances',
					subtitle: '',
					info:
						'Appliances includes refrigerators and freezers, dishwashers and garbage disposals, stoves and ovens, vacuum cleaners, microwaves, air-conditioners, sewing machines, washing machines and dryers, and floor cleaning equipment, and small electrical kitchen appliances such as portable heating and cooling equipment, china and other dinnerware, flatware, glassware, silver and other serving pieces, nonelectric cookware, and plastic dinnerware (excludes personal care appliances). '
				},
				{
					title: 'Miscellaneous household equipment',
					subtitle: '',
					info:
						'Miscellaneous household equipment includes typewriters, luggage, lamps and light fixtures, window coverings, clocks, lawnmowers and gardening equipment, other hand and power tools, telephone answering devices, telephones and accessories, computers and computer hardware for home use, computer software and accessories for home use, calculators, business equipment for home use, floral arrangements and house plants, rental of furniture, closet and storage items, other household decorative items, infants equipment, outdoor equipment, smoke alarms, other household appliances, and other small miscellaneous furnishings.'
				},
				{
					title: 'Gardening',
					subtitle: '(plants, pots, tools, dirt)',
					info:
						'Gardening includes spendings for plants, pots, tools, dirt, lawn care services etc.. '
				},
				{
					title: 'Other household expenses',
					subtitle: '(input your own)',
					info:
						'Other household expenses includes housekeeping services, coin-operated laundry and dry-cleaning (non-clothing), termite and pest control products and services, home security systems service fees, moving, storage, and freight expenses, repair of household appliances and other household equipment, repair of computer systems for home use, computer information services, reupholstering and furniture repair and rental of household equipment.'
				}
			]
		]
	},

	{
		title: 'Clothing and Accessories',
		color: '#20355F',
		rows: [
			[
				{
					title: 'Clothes',
					subtitle: '(jackets, pants, shirts, socks, etc..)',
					info: ''
				},
				{
					title: 'Shoes',
					subtitle: '(sneakers, slippers, sandals, etc..)',
					info: ''
				},
				{
					title: 'Bags',
					subtitle: '(ladies handbags, backpacks, suitcases, etc..)',
					info: ''
				},
				{
					title: 'Accessories ',
					subtitle: '(bracelets, necklaces, earrings, watches etc..)',
					info: ''
				}
			],
			[
				{
					title: 'Personal electronics',
					subtitle: '(smartphone, tablets, laptops, etc..)',
					info: ''
				},
				{
					title: 'Other',
					subtitle: '(input your own)',
					info: ''
				}
			]
		]
	},

	{
		title: 'Transportation',
		color: '#F98155',
		rows: [
			[
				{
					title: 'Vehicle purchases',
					subtitle: '(net outlay)',
					info:
						'Vehicle purchases (net outlay) includes the net outlay (purchase price minus trade-in value) on new and used domestic and imported cars and trucks and other vehicles, including motorcycles and private planes.'
				},
				{
					title: 'Vehicle finance charges',
					subtitle: '',
					info:
						'Vehicle finance charges includes the dollar amount of interest paid for a loan contracted for the purchase of vehicles described above.'
				},
				{
					title: 'Vehicle insurance',
					subtitle: '',
					info:
						'Vehicle insurance includes the premium paid for insuring cars, trucks, and other vehicles.'
				},
				{
					title: 'Gasoline and motor oil',
					subtitle: '',
					info:
						'Gasoline and motor oil includes gasoline, diesel fuel, and motor oil.'
				}
			],
			[
				{
					title: 'Maintenance and repairs',
					subtitle: '',
					info:
						'Maintenance and repairs includes tires, batteries, tubes, lubrication, filters, coolant, additives, brake and transmission fluids, oil change, brake work including adjustment, front-end alignment, wheel balancing, steering repair, shock absorber replacement, clutch and transmission repair, electrical system repair, exhaust system repair, body work and painting, motor repair, repair to cooling system, drive train repair, drive shaft and rear-end repair, tire repair, audio equipment, other maintenance and services, and auto repair policies.'
				},
				{
					title: 'Public transportation',
					subtitle: '',
					info:
						'Public transportation includes fares for mass transit, buses, trains, airlines, taxis, school buses for which a fee is charged, and boats.'
				},
				{
					title: 'Vehicle rental',
					subtitle: '(leases, licenses, etc..)',
					info:
						"Vehicle rental, leases, licenses, and other charges includes leased and rented cars, trucks, motorcycles, and aircraft; inspection fees; State and local registration; driver's license fees; parking fees; towing charges; tolls; and automobile service clubs."
				},
				{
					title: 'Ridesharing',
					subtitle: '(i.e., Uber, Lyft)',
					info: ''
				}
			],
			[
				{
					title: 'Flights',
					subtitle: '(tickets, fees, etc..)',
					info: ''
				},
				{
					title: 'Cruise',
					subtitle: '',
					info: ''
				},
				{
					title: 'Other',
					subtitle: '(input your own)',
					info: ''
				}
			]
		]
	},

	{
		title: 'Healthcare',
		color: '#BEBFBF',
		rows: [
			[
				{
					title: 'Health insurance',
					subtitle: '',
					info:
						"Health insurance includes traditional fee-for-service health plans, preferred-provider health plans, health maintenance organizations (HMO's), commercial Medicare supplements, and other health insurance."
				},
				{
					title: 'Medical services',
					subtitle: '',
					info:
						"Medical services includes hospital room and services, physicians' services, service by a professional other than a physician, eye and dental care, lab tests and X-rays, medical care in a retirement community, care in convalescent or nursing home, and other medical care service."
				},
				{
					title: 'Drugs',
					subtitle: '',
					info:
						'Drugs includes nonprescription drugs and vitamins and prescription drugs.'
				},
				{
					title: 'Medical supplies ',
					subtitle: '',
					info:
						'Medical supplies includes topicals and dressings, antiseptics, bandages, cotton, first aid kits, contraceptives, syringes, ice bags, thermometers, sun lamps, vaporizers, heating pads, medical appliances (such as braces, canes, crutches, walkers, eyeglasses, and hearing aids), and rental and repair of medical equipment.'
				}
			],
			[
				{
					title: 'Salon/Hair/Nails',
					subtitle:
						'(spa procedures, other beauty procedures, etc..)',
					info: ''
				},
				{
					title: 'Fitness',
					subtitle:
						'(weights, exercise bikes, fitness accessories, etc..)',
					info:
						' Fitness includes all fitness accessories and equipment such as: treadmills, exercise bikes, weights, fitness foods or beverages, other fitness products ot fees.'
				},
				{
					title: 'Personal care products and services',
					subtitle: '(hygiene, makeup products)',
					info: ''
				},
				{
					title: 'Other',
					subtitle: '(input your own) ',
					info: ''
				}
			]
		]
	},

	{
		title: 'Entertainment',
		color: '#FBD458',
		rows: [
			[
				{
					title: 'Bars',
					subtitle: '',
					info:
						'Bars includes spendings for bars, night clubs, discos, etc..'
				},
				{
					title: 'Events',
					subtitle: '(opera, concerts, cinema, ballet…)',
					info: ''
				},
				{
					title: 'Television, internet, radio, and sound equipment',
					subtitle: '',
					info: ''
				},
				{
					title: 'Toys, hobbies, and playground equipment',
					subtitle: '',
					info: ''
				}
			],
			[
				{
					title: 'Pets',
					subtitle: '(food, health, supplies, etc..)',
					info: ''
				},
				{
					title: 'Books, magazines',
					subtitle: '',
					info: ''
				},
				{
					title: 'Clubs or Group membership fees',
					subtitle: '',
					info: ''
				},
				{
					title: 'Other entertainment equipment and services',
					subtitle: '(input your own) ',
					info: ''
				}
			]
		]
	},

	{
		title: 'Other expenditures',
		color: '#88A1CE',
		rows: [
			[
				{
					title: 'Gifts for others',
					subtitle:
						'(gifts for birthdays, holidays and other special occasions)',
					info: ''
				},
				{
					title: 'Donations to charity',
					subtitle: '',
					info: ''
				},
				{
					title: 'Education',
					subtitle: '(courses, online courses, tutorials, etc..)',
					info: ''
				},
				{
					title: 'Personal vices',
					subtitle: '(tobacco, desserts, coffee)',
					info: ''
				}
			],
			[
				{
					title: 'Miscellaneous',
					subtitle: '',
					info: ''
				},
				{
					title: 'Apps and software',
					subtitle:
						'(online subscriptions, software programs and other apps fees)',
					info: ''
				},
				{
					title: 'Other',
					subtitle: '(input your own)',
					info: ''
				}
			]
		]
	}
];
